module.exports = __webpack_public_path__ + "img/img4box.da8f6e7e.png";